import React from "react";
import CTAButton from "./CTAButton";

const Hero = () => {
  return (
    <section className="hero">
      <div className="backdrop" />
      <div className="container relative" style={{ position: "relative", zIndex: 2 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 28 }}>
          <div style={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: 900,
            fontStyle: "italic",
            fontSize: 44,
            letterSpacing: "-2px",
            color: "#fff",
            display: "inline-block",
          }}>
            V<span style={{ color: "#F5C400" }}>S</span>A
          </div>
        </div>
        <h1 className="h-title yellow" style={{ maxWidth: 900, margin: "0 auto" }}>
          A Maior Comunidade no TikTok Shop
          <span style={{ color: "#fff" }}> com IA, </span>
          que já gerou
          <span style={{ color: "#fff" }}> +R$1.000.000 em GMV </span>
          no TikTokShop.
        </h1>
        <p style={{
          maxWidth: 760,
          margin: "28px auto 0",
          fontSize: 18,
          lineHeight: 1.6,
          color: "rgba(255,255,255,0.85)",
        }}>
          <strong>O método para fazer R$15.000/mês com TikTok Shop, começando do zero e sem investir um centavo em tráfego</strong>, usando a estratégia certa para criar vídeos que vendem, <strong>aparecendo ou sem aparecer.</strong>
        </p>
        <div style={{ marginTop: 40, display: "flex", justifyContent: "center" }}>
          <CTAButton />
        </div>
        <div style={{ marginTop: 30, display: "flex", justifyContent: "center", alignItems: "center", gap: 12 }}>
          <div style={{ display: "flex" }}>
            {[1, 2, 3].map(i => (
              <div key={i} style={{
                width: 34, height: 34, borderRadius: 999,
                background: `linear-gradient(135deg, hsl(${i * 60}, 70%, 60%), hsl(${i * 60 + 40}, 70%, 40%))`,
                border: "2px solid #000",
                marginLeft: i === 1 ? 0 : -10,
              }} />
            ))}
          </div>
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 13, letterSpacing: 1 }}>+1.000 MEMBROS ATIVOS</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
